module.exports = __webpack_public_path__ + "static/img/101085.a102b11a.png";